module.exports = __webpack_public_path__ + "img/pin.938a4f5a.png";